<template>
  <div class="grid gap-4 p-6">
    <!--header-->
    <div class="flex flex-col space-y-1.5 text-center sm:text-left">
      <h2 class="text-lg font-semibold leading-none tracking-tight">
        ESL Tag Status List
      </h2>
      <p class="text-sm text-muted-foreground">
        View the status of your selected ESL tags
      </p>
      <!--body-->
      <el-table
        v-if="tableCtrl"
        :data="tableCtrl.state.tableData"
        v-loading="tableCtrl.state.loading"
        element-loading-background="rgba(24, 33, 48, 0.8)" 
        style="width: 100%"
        border
      >
        <el-table-column prop="esl_code" label="ESL Code" width="160" />
        <el-table-column prop="esl_version" label="Version" width="120" />
        <el-table-column prop="online" label="Online" width="80">
          <template #default="{ row }">
            <el-tag :type="row.online ? 'success' : 'info'">
              {{ row.online ? "Online" : "Offline" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="esl_battery" label="Battery" width="100" />
        <el-table-column prop="product_code" label="Product Code" width="140" />
        <el-table-column prop="ap_code" label="AP Code" width="160" />
        <el-table-column prop="esltype_code" label="Type" width="120" />
        <el-table-column prop="refreshed_at" label="Refresh Time" />
        <el-table-column prop="retrieved_at" label="Collection Time" />
      </el-table>

      <div class="flex flex-row justify-end">
        <el-pagination
          @size-change="(val) => tableCtrl.setPageSize(val)"
          @current-change="(val) => tableCtrl.setCurrentPage(val)"
          :current-page="tableCtrl.state.pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="tableCtrl.state.pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableCtrl.state.pagination.total"
        />
      </div>

      <!--close-->
      <button
        type="button"
        @click="$emit('cancel')"
        class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
      >
        <i class="el-icon-close"></i>
        <span class="sr-only">Close</span>
      </button>
    </div>
  </div>
</template>

<script>
import { TableController } from "@/controllers/TableController";
import { getEslTagStatus } from "@/api";

export default {
  name: "EtagStatusList",
  emits: ["input"],
  props: {
    etagCodes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableCtrl: null,
    };
  },
  watch: {
    etagCodes: {
      handler() {
        this.reloadTable();
      },
      immediate: true,
    },
  },
  created() {
    this.initTableController();
  },
  methods: {
    async fetchData() {
      return await getEslTagStatus({
        f3: this.etagCodes,
      });
    },
    initTableController() {
      this.tableCtrl = new TableController({
        loadMethod: this.fetchData,
        isClientPaged: true,
        pageField: "f1",
        pageSizeField: "f2",
        keyField: "esl_code",
        autoLoad: true,
      });
    },
    reloadTable() {
      if (this.tableCtrl) {
        this.tableCtrl.setCurrentPage(1);
        this.tableCtrl.loadTableData();
      }
    },
  },
};
</script>
